import { useState, forwardRef, useEffect } from "react";
import { NavLink, useParams, useNavigate} from 'react-router-dom';
import DatosCabezaFamilia from './../DatosCabezaFamilia.jsx';
import { Tooltip } from 'react-tooltip';
import DataTable from 'react-data-table-component';
import SweetAlert2 from 'react-sweetalert2';
import apiService from '../../../Auth/apiService.jsx';
import { useAuth } from '../../../Auth/AuthContext.jsx';
import MenuCaracterizacion from "../Componentes/MenuCaracterizacion.jsx";
import { FaFile } from "react-icons/fa";

export default function Carpeta(){
    const { token, rol } = useAuth();
    const navigate = useNavigate();
    const [Cargando, setCargando] = useState(false);
    const { idCabezaFamilia } = useParams();
    const [swalProps, setSwalProps] = useState();
    const [CabezaFamiliaDatos, setCabezaFamiliaDatos] = useState({
        nombre: '',
        cab_idcabezafamilia: '',
        cab_direccion: '',
        telefono: '',
        cab_celular: '',
        cab_correoelectronico: '',
        cab_nodeclaracion: ''
      });
      const [archivos, setArchivos] = useState([]);
      const columns = [
        {
            name: 'Acciones',
            cell: row => (
            <div>
                <button type="button" onClick={() => verarchivo(row)} 
                        style={{backgroundColor: 'skyblue'}} 
                        data-tooltip-id='tooltiparriba'
                        data-tooltip-content="Ver acta">
                    <FaFile/>
                </button>
                
            </div>
            ),
            ignoreRowClick: true,
            width: '8%'
        },
        { name: 'Id', selector: row => row.id, sortable: true, width:'10%' },
        { name: 'Fecha', selector: row => row.carFecha, sortable: true, width: '12%'},
        { name: 'Nombre', selector: row => row.carNombre, sortable: true, width: '20%' },
        { name: 'Observaciones', selector: row => row.carObservaciones, sortable: true, width: '50%' }
    ];
    const verarchivo =  (async (row) =>{
        setCargando(true);
        let url;
        url = '/archivo/downfilepdf';
        try {
            const obj = {idFile: row.id , nombre: row.carNombre, usrRolid: rol }
            
            const response = await apiService.getFile(url, obj, token);
            console.log(response);
            if(response.status === 200){
                const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
                const link = document.createElement('a');
                link.href = url;
                link.download = row.carNombre || 'downloaded-file.pdf';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            }
        } catch (error) {
            
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    });
    useEffect(() => {
    
        const fetchData = async () => {
            let url = '/archivo/listararchivosimg';
            let obj = {idCabezaFamilia: idCabezaFamilia, usrRolid: rol }
            try {
                setCargando(true);
                const response = await apiService.post(url, obj, token);
                const result = await response.data;
                setCabezaFamiliaDatos(result.cabezafamilia);
                setArchivos(result.archivos);
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setCargando(false);
            }
            
            
        };
        fetchData();
    }, []);
    return (
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">Carpeta</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><NavLink to={`/`} >Inicio</NavLink></li>
                        {idCabezaFamilia !== "0" && <li className="breadcrumb-item"><NavLink to={`/caracterizacion/grupofamiliar/${idCabezaFamilia}`} >Grupo familiar</NavLink></li>}
                        <li className="breadcrumb-item active"> Carpeta</li>
                        </ol>
                    </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                      {Cargando && <div className="centered">
                        <div><progress value={null} /></div>
                      </div>}
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    <MenuCaracterizacion idCabezaFamilia={idCabezaFamilia} />
                    <DatosCabezaFamilia datos={CabezaFamiliaDatos}/>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className="card-tools">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <NavLink to={`/archivo/subirarchivo/${idCabezaFamilia}`}>
                                                    <FaFile className="nav-icon" style={{marginRight: '5px'}}/> Subir archivo
                                                </NavLink>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                {/* /.card-header */}
                            
                            {/* /.card-body */}
                            </div>
                            {/* /.card */}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card-body table-responsive p-0">
                                <DataTable
                                    title="Archivos en Carpeta"
                                    columns={columns}
                                    data={archivos}
                                    progressPending={Cargando}
                                    pagination
                                    noDataComponent="No hay datos para mostrar"
                                /> 
                            </div>
                        </div>
                    </div>
                </div>{/* /.container-fluid */}
                <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
                <Tooltip id="tooltiparriba" place="right"/>
            </section>
        </div>
    );
}